import 'ion-rangeslider'

export const academicSlider = {
    init: (selector, stateSelector, min, max, step, relatedSelector, relatedStateSelector) => {
        const stateElm = $(stateSelector);
        $(selector).ionRangeSlider({
            min, max, step,
            block: !stateElm.is(":checked"),
            onStart: function () {
                $(`<div class="slider-data-wrapper"><div class="slider-data ${selector.substr(1)}-data-from"></div><div class="slider-data slider-data-val ${selector.substr(1)}-data-val"></div><div class="slider-data ${selector.substr(1)}-data-to"></div></div>`).insertAfter($(selector));
            },
            onChange: function () {
                let val = $(selector).data('ionRangeSlider');
                academicSlider.displaySliderData(selector + '-data-from', selector + '-data-to', selector + '-data-val', val.result.min, val.result.max, val.result.from)
                if (relatedSelector) {
                    const related_selector_instance = $(relatedSelector).data("ionRangeSlider");
                    academicSlider.updateGpaSlider(max, val.result.from, related_selector_instance);
                }
            },
            onUpdate: function () {
                let val = $(selector).data('ionRangeSlider');
                academicSlider.displaySliderData(selector + '-data-from', selector + '-data-to',selector + '-data-val', val.result.min, val.result.max, val.result.from)
            },
        });
        const selector_instance = $(selector).data("ionRangeSlider");
        selector_instance && selector_instance.reset();

        stateElm.change(function () {
            if($(this).is(":checked")){
                selector_instance.update({block: false});
                if (relatedSelector && relatedStateSelector) {
                    const related_selector_instance = $(relatedSelector).data("ionRangeSlider");
                    related_selector_instance.update({block: false});
                    $(relatedStateSelector).prop("checked", true);
                }
            } else {
                selector_instance.update({block: true});
                if (relatedSelector && relatedStateSelector) {
                    const related_selector_instance = $(relatedSelector).data("ionRangeSlider");
                    related_selector_instance.update({block: true});
                    $(relatedStateSelector).prop("checked", false);
                }
            }
        });
    },
    displaySliderData: (from_field, to_field, val_field, from, to, val) => {
        $(from_field).html(from)
        $(to_field).html(to)
        $(val_field).html(val)
    },
    updateGpaSlider: (max, value, selector) => {
        let v = 0;
        if (max === 100){
            v = 1.0;
            if (value >= 95){
                v = 4.0;
            } else {
                v = 1.0 + (value - 65) / 10;
                v = parseFloat(v).toFixed( 2 );
            }
        }
        if (max === 4) {
            v = 65;
            if (value >= 4.0){
                v = 95;
            } else {
                v = 65 + (value - 1) * 10
            }
        }
        selector.update({from: v});
    }
};